import UserContentHighlight from 'types/UserContentHighlight';
import UserContentNote from 'types/UserContentNote';

const importUserContent = (book, { bookInfo, highlights, notes }) => {
  if (book.pk !== bookInfo.id) {
    console.warn('not the same book');
    return;
  }
  for (let highlight of highlights) {
    highlight.book = book;
    let userContentHighlight = new UserContentHighlight(highlight);
    userContentHighlight.save();
  }
  for (let note of notes) {
    note.book = book;
    let userContentNote = new UserContentNote(note);
    userContentNote.save();
  }
};

export default importUserContent;
